// import React, { useContext, useEffect, useState, useRef } from 'react';
// import { DContext } from '../context/Datacontext';
// import Loading from './Loading';
// import { fetchConversations, fetchConversationMessages, sendMessage } from '../services/user/messagingService';
// import { compressImage } from '../utils/compressImages';
// import {
//     FiSend,
//     FiImage,
//     FiLoader,
//     FiCheck,
//     FiCheckCircle,
//     FiSearch,
//     FiX,
//     FiDownload,
//     FiZoomIn,
//     FiZoomOut,
// } from 'react-icons/fi';
// import { LuFullscreen } from "react-icons/lu";
// import { IoClose } from "react-icons/io5";

// function Messages({ course, setShowMessager }) {
//     const { BeURL, currentUser } = useContext(DContext);
//     const [loading, setLoading] = useState(true);
//     const [conversations, setConversations] = useState([]);
//     const [selectedConversation, setSelectedConversation] = useState(null);
//     const [messages, setMessages] = useState([]);
//     const [messageInput, setMessageInput] = useState('');
//     const [selectedImage, setSelectedImage] = useState(null);
//     const [imagePreview, setImagePreview] = useState(null);
//     const [sending, setSending] = useState(false);
//     const [sendingMessageText, setSendingMessageText] = useState('');
//     const [sendingImagePreview, setSendingImagePreview] = useState(null);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [loadingMessages, setLoadingMessages] = useState(false);
//     const [hasNewMessages, setHasNewMessages] = useState(false);
//     const [viewingImage, setViewingImage] = useState(null);
//     const [imageZoom, setImageZoom] = useState(1);
//     const [currentRole,setCurrentRole]=useState(false)
//     const messagesEndRef = useRef(null);
//     const fileInputRef = useRef(null);
//     const previousMessagesRef = useRef([]);
//     const previousConversationsRef = useRef([]);
//     const isTypingRef = useRef(false);
//     const typingTimeoutRef = useRef(null);


//     useEffect(()=>{
//        if(currentUser?.role === "user"){
//         setCurrentRole(true)
//        }
//     },[currentUser])


//     // Fetch conversations
//     useEffect(() => {
//         if (!BeURL || !currentUser) return;

//         const fetchData = async () => {
//             try {
//                 // Only show loading on initial fetch
//                 if (previousConversationsRef.current.length === 0) {
//                     setLoading(true);
//                 }

//                 // Skip fetch if user is typing
//                 if (isTypingRef.current) {
//                     return;
//                 }

//                 const result = await fetchConversations({ BeURL });
//                 if (result.success) {
//                     const newConversations = result.conversations || [];
//                     const newConversationsStr = JSON.stringify(newConversations.map(c => ({
//                         id: c._id,
//                         updatedAt: c.updatedAt,
//                         lastMessage: c.lastMessage?._id
//                     })));
//                     const previousConversationsStr = JSON.stringify(previousConversationsRef.current.map(c => ({
//                         id: c._id,
//                         updatedAt: c.updatedAt,
//                         lastMessage: c.lastMessage?._id
//                     })));

//                     // Only update state if conversations actually changed
//                     // if (newConversationsStr !== previousConversationsStr) {
//                     //     setConversations(newConversations);
//                     //     previousConversationsRef.current = newConversations;

//                     //     // Auto-select first conversation only on initial load
//                     //     if (previousConversationsRef.current.length === 0 && newConversations.length > 0) {
//                     //         setSelectedConversation(newConversations[0]);
//                     //     }
//                     // }

//                     if (newConversationsStr !== previousConversationsStr) {
//                         setConversations(newConversations);

//                         //Check BEFORE updating ref
//                         const isFirstLoad = previousConversationsRef.current.length === 0;

//                         previousConversationsRef.current = newConversations;

//                         //Only on first load → auto select first chat
//                         if (isFirstLoad && newConversations.length > 0) {
//                             setSelectedConversation(newConversations[0]);
//                         }
//                     }
//                 }
//             } catch (error) {
//                 console.error('Error loading conversations:', error);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//         // Increased interval to 15 seconds to reduce re-renders
//         const interval = setInterval(fetchData, 15000);
//         return () => clearInterval(interval);
//     }, [BeURL, currentUser]);

//     // Fetch messages when conversation is selected
//     useEffect(() => {
//         if (!selectedConversation || !BeURL) return;

//         let isFirstLoad = true;

//         const fetchMessages = async () => {
//             try {
//                 // Skip fetch if user is typing
//                 if (isTypingRef.current && !isFirstLoad) {
//                     return;
//                 }

//                 // Only show loading spinner on first load
//                 if (isFirstLoad) {
//                     setLoadingMessages(true);
//                 }

//                 const result = await fetchConversationMessages({
//                     BeURL,
//                     conversationId: selectedConversation._id,
//                     page: 1,
//                     limit: 50
//                 });

//                 if (result.success) {
//                     const newMessages = result.messages || [];
//                     const newMessagesStr = JSON.stringify(newMessages.map(m => ({
//                         id: m._id,
//                         isRead: m.isRead
//                     })));
//                     const previousMessagesStr = JSON.stringify(previousMessagesRef.current.map(m => ({
//                         id: m._id,
//                         isRead: m.isRead
//                     })));

//                     // Only update state if messages actually changed (including read status)
//                     if (newMessagesStr !== previousMessagesStr) {
//                         const previousLength = previousMessagesRef.current.length;
//                         setMessages(newMessages);
//                         previousMessagesRef.current = newMessages;

//                         // Show notification if new messages arrived (not on first load)
//                         // AND the new message is from the OTHER person (not current user)
//                         if (!isFirstLoad && newMessages.length > previousLength) {
//                             const latestMessage = newMessages[newMessages.length - 1];
//                             const senderIdStr = typeof latestMessage?.senderId === 'string'
//                                 ? latestMessage.senderId
//                                 : latestMessage?.senderId?._id || '';
//                             const currentUserIdStr = currentUser?._id || '';
//                             const isFromOtherPerson = senderIdStr !== currentUserIdStr;

//                             if (isFromOtherPerson) {
//                                 setHasNewMessages(true);
//                             }
//                         }
//                     }

//                     // Clear loading only after first fetch completes
//                     if (isFirstLoad) {
//                         setLoadingMessages(false);
//                         isFirstLoad = false;
//                     }
//                 }
//             } catch (error) {
//                 console.error('Error loading messages:', error);
//                 if (isFirstLoad) {
//                     setLoadingMessages(false);
//                     isFirstLoad = false;
//                 }
//             }
//         };

//         // Fetch on conversation change
//         fetchMessages();

//         // Dynamic interval: Poll faster (3s) when there are unread sent messages, otherwise normal (20s)
//         const checkInterval = () => {
//             const currentUserIdStr = currentUser?._id || '';
//             const hasUnreadSentMessages = messages.some(msg => {
//                 const senderIdStr = typeof msg.senderId === 'string' ? msg.senderId : msg.senderId?._id || '';
//                 return senderIdStr === currentUserIdStr && !msg.isRead;
//             });
//             return hasUnreadSentMessages ? 3000 : 20000;
//         };

//         let interval = setInterval(fetchMessages, checkInterval());

//         // Re-evaluate interval when messages change
//         const updateInterval = () => {
//             clearInterval(interval);
//             interval = setInterval(fetchMessages, checkInterval());
//         };

//         // Update interval every 3 seconds to adapt to message state changes
//         const intervalUpdater = setInterval(updateInterval, 3000);

//         return () => {
//             clearInterval(interval);
//             clearInterval(intervalUpdater);
//         };
//     }, [selectedConversation, BeURL, messages, currentUser]);

//     // Handle scroll to new messages
//     const handleScrollToNewMessages = () => {
//         messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//         setHasNewMessages(false);
//     };

//     // Reset new messages flag when changing conversations
//     useEffect(() => {
//         setHasNewMessages(false);
//     }, [selectedConversation]);

//     // Cleanup typing timeout on unmount
//     useEffect(() => {
//         return () => {
//             if (typingTimeoutRef.current) {
//                 clearTimeout(typingTimeoutRef.current);
//             }
//         };
//     }, []);

//     // Handle message input change with typing detection
//     const handleMessageInputChange = (e) => {
//         setMessageInput(e.target.value);

//         // Set typing flag
//         isTypingRef.current = true;

//         // Clear existing timeout
//         if (typingTimeoutRef.current) {
//             clearTimeout(typingTimeoutRef.current);
//         }

//         // Clear typing flag after 3 seconds of no typing
//         typingTimeoutRef.current = setTimeout(() => {
//             isTypingRef.current = false;
//         }, 3000);
//     };

//     // Handle image selection
//     const handleImageSelect = async (e) => {
//         const file = e.target.files?.[0];
//         if (!file) return;

//         try {
//             const compressed = await compressImage(file);
//             const reader = new FileReader();
//             reader.onloadend = () => {
//                 setSelectedImage(reader.result);
//                 setImagePreview(URL.createObjectURL(compressed));
//             };
//             reader.readAsDataURL(compressed);
//         } catch (error) {
//             console.error('Error processing image:', error);
//         }
//     };

//     // Send message
//     const handleSendMessage = async (e) => {
//         e.preventDefault();
//         // Allow sending if either text OR image is present
//         if ((!messageInput.trim() && !selectedImage) || !selectedConversation || sending) return;

//         try {
//             setSending(true);
//             // Preserve current message content for sending indicator
//             setSendingMessageText(messageInput);
//             setSendingImagePreview(imagePreview);

//             const result = await sendMessage({
//                 BeURL,
//                 conversationId: selectedConversation._id,
//                 content: messageInput,
//                 imageData: selectedImage
//             });

//             if (result.success) {
//                 setMessages([...messages, result.data]);
//                 setMessageInput('');
//                 setSelectedImage(null);
//                 setImagePreview(null);

//                 // Clear typing flag and timeout after sending
//                 isTypingRef.current = false;
//                 if (typingTimeoutRef.current) {
//                     clearTimeout(typingTimeoutRef.current);
//                     typingTimeoutRef.current = null;
//                 }

//                 // Auto-scroll to bottom after sending message
//                 setTimeout(() => {
//                     messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
//                 }, 100);
//             } else {
//                 // Show error message to user
//                 alert(result.message || 'Failed to send message. Please try again.');
//             }
//         } catch (error) {
//             console.error('Error sending message:', error);
//             alert('Error sending message. Please check your connection and try again.');
//         } finally {
//             setSending(false);
//             setSendingMessageText('');
//             setSendingImagePreview(null);
//         }
//     };

//     // Filter conversations
//     const filteredConversations = conversations.filter(conv => {
//         const otherPerson = currentUser.role === 'user'
//             ? conv.instructorId
//             : conv.studentId;
//         const name = otherPerson?.fullName || '';
//         const courseName = conv.courseId?.title || '';
//         return name.toLowerCase().includes(searchTerm.toLowerCase()) ||
//             courseName.toLowerCase().includes(searchTerm.toLowerCase());
//     });

//     // Get other person info
//     const getOtherPerson = (conv) => {
//         return currentUser.role === 'user' ? conv.instructorId : conv.studentId;
//     };

//     // Format time
//     const formatTime = (date) => {
//         const d = new Date(date);
//         return d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
//     };

//     // Handle image view
//     const handleImageClick = (imageSrc) => {
//         setViewingImage(imageSrc);
//         setImageZoom(1);
//     };

//     // Close image viewer
//     const closeImageViewer = () => {
//         setViewingImage(null);
//         setImageZoom(1);
//     };

//     // Download image
//     const downloadImage = () => {
//         if (!viewingImage) return;
//         const link = document.createElement('a');
//         link.href = viewingImage;
//         link.download = `message-image-${Date.now()}.jpg`;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };

//     // Zoom functions
//     const zoomIn = () => setImageZoom(prev => Math.min(prev + 0.25, 3));
//     const zoomOut = () => setImageZoom(prev => Math.max(prev - 0.25, 0.5));

//     if (loading) return <Loading />;

//     return (
//         <div className={`${currentRole ? "h-[60vh]" : "h-[80vh]"} border  rounded-xl flex overflow-hidden`}>
//             {/* Conversations List */}
//             <div className="w-full lg:w-80 border-r border-gray-200 bg-white flex flex-col">
//                 {/* Header */}
//                 <div className="p-4 border-b border-gray-200">
//                     <h2 className="text-xl font-bold text-gray-900 mb-4">Messages</h2>
//                     <div className="relative">
//                         <FiSearch className="absolute left-3 top-2.5 text-gray-400" size={18} />
//                         <input
//                             type="text"
//                             placeholder="Search conversations..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             className="w-full pl-10 pr-4 py-2 bg-gray-100 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-600 transition-all"
//                         />
//                     </div>
//                 </div>

//                 {/* Conversations */}
//                 <div className="flex-1 overflow-y-auto">
//                     {filteredConversations.length === 0 ? (
//                         <div className="p-6 text-center text-gray-400">
//                             <p className="text-sm">No conversations yet</p>
//                         </div>
//                     ) : (
//                         filteredConversations.map((conv) => {
//                             const otherPerson = getOtherPerson(conv);
//                             const isSelected = selectedConversation?._id === conv._id;
//                             const lastMsg = conv.lastMessage;

//                             return (
//                                 <button
//                                     key={conv._id}
//                                     onClick={() => {
//                                         setSelectedConversation(conv);
//                                         setMessages([]);
//                                     }}
//                                     className={`w-full flex items-center gap-3 px-4 py-3 
//             border-b border-gray-100 text-left 
//             transition-all duration-200 
//             active:bg-gray-100 
//             ${isSelected ? "bg-primary-50 border-l-4 border-l-primary-600" : "hover:bg-gray-50"}
//           `}
//                                 >
//                                     {/* Avatar */}
//                                     <div className="w-11 h-11 sm:w-10 sm:h-10 rounded-full 
//             bg-gradient-to-br from-primary-600 to-secondary-600 
//             flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
//                                         {otherPerson?.fullName?.charAt(0) || "U"}
//                                     </div>

//                                     {/* Content */}
//                                     <div className="flex-1 min-w-0">
//                                         {/* Name + Time */}
//                                         <div className="flex justify-between items-center">
//                                             <p className="font-semibold text-gray-900 text-sm truncate">
//                                                 {otherPerson?.fullName || "User"}
//                                             </p>

//                                             {/* Time */}
//                                             {lastMsg?.createdAt && (
//                                                 <span className="text-[10px] text-gray-400 ml-2 whitespace-nowrap">
//                                                     {new Date(lastMsg.createdAt).toLocaleTimeString([], {
//                                                         hour: "2-digit",
//                                                         minute: "2-digit",
//                                                     })}
//                                                 </span>
//                                             )}
//                                         </div>

//                                         {/* Course */}
//                                         <p className="text-[11px] text-gray-500 truncate">
//                                             {conv.courseId?.title || "Course"}
//                                         </p>

//                                         {/* Last Message */}
//                                         {lastMsg && (
//                                             <p className="text-xs text-gray-600 truncate mt-0.5">
//                                                 {lastMsg.content}
//                                             </p>
//                                         )}
//                                     </div>
//                                 </button>
//                             );
//                         })
//                     )}
//                 </div>
//             </div>

//             {/* Messages Panel */}
//             {selectedConversation ? (
//                 <div className="flex flex-1 flex-col bg-white">
//                     {/* Header */}
//                     <div className="h-16 border-b border-gray-200 flex items-center justify-between px-6 bg-white shadow-sm">
//                         <div>
//                             <h3 className="font-semibold text-gray-900">
//                                 {getOtherPerson(selectedConversation)?.fullName || 'User'}
//                             </h3>
//                             <p className="text-xs text-gray-500">
//                                 {selectedConversation.courseId?.title || 'Course'}
//                             </p>
//                         </div>
//                         <button onClick={()=>setShowMessager(false)}>
//                             {currentRole && <IoClose />}
//                         </button>
//                     </div>

//                     {/* Messages */}
//                     <div className="flex-1 overflow-y-auto p-6 space-y-4 bg-gray-50">
//                         {loadingMessages ? (
//                             <div className="flex items-center justify-center h-full">
//                                 <FiLoader className="animate-spin text-primary-600" size={24} />
//                             </div>
//                         ) : messages.length === 0 ? (
//                             <div className="flex items-center justify-center h-full text-center">
//                                 <div>
//                                     <p className="text-gray-500">No messages yet</p>
//                                     <p className="text-xs text-gray-400 mt-2">Start the conversation!</p>
//                                 </div>
//                             </div>
//                         ) : (
//                             <>
//                                 {messages.map((msg) => {
//                                     // Handle both object and string formats for senderId
//                                     const senderIdStr = typeof msg.senderId === 'string' ? msg.senderId : msg.senderId?._id || '';
//                                     const currentUserIdStr = currentUser._id || '';
//                                     const isSender = senderIdStr === currentUserIdStr;

//                                     return (
//                                         <div
//                                             key={msg._id}
//                                             className={`flex gap-3 animate-fadeIn ${isSender ? 'justify-end' : 'justify-start'}`}
//                                         >
//                                             <div className={`max-w-xs lg:max-w-md ${isSender ? 'order-2' : 'order-1'}`}>
//                                                 {msg.image && (
//                                                     <div
//                                                         className="mb-2 rounded-lg overflow-hidden cursor-pointer relative group"
//                                                         onClick={() => handleImageClick(msg.image)}
//                                                     >
//                                                         <img
//                                                             src={msg.image}
//                                                             alt="Message"
//                                                             className="max-w-xs h-auto rounded-lg shadow-sm transition-opacity group-hover:opacity-75"
//                                                         />
//                                                         {/* Hover Overlay */}
//                                                         <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-200 flex items-center justify-center">
//                                                             <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex flex-col items-center gap-2">
//                                                                 <div className="p-3 bg-white rounded-full shadow-lg">
//                                                                     <LuFullscreen size={24} className="text-primary-600" />
//                                                                 </div>
//                                                                 <span className="text-white font-semibold text-sm">View Image</span>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 )}
//                                                 {msg.content && (
//                                                     <div
//                                                         className={`px-4 py-2.5 rounded-lg shadow-sm ${isSender
//                                                             ? 'bg-primary-600 text-white rounded-br-none'
//                                                             : 'bg-white text-gray-900 rounded-bl-none border border-gray-200'
//                                                             }`}
//                                                     >
//                                                         <p className="break-words text-sm leading-relaxed">{msg.content}</p>
//                                                         <p className={`text-xs mt-1.5 flex items-center gap-1.5 ${isSender ? 'text-primary-100' : 'text-gray-500'
//                                                             }`}>
//                                                             {formatTime(msg.createdAt)}
//                                                             {isSender && (
//                                                                 msg.isRead ? (
//                                                                     <FiCheckCircle size={12} className="flex-shrink-0" />
//                                                                 ) : (
//                                                                     <FiCheck size={12} className="flex-shrink-0" />
//                                                                 )
//                                                             )}
//                                                         </p>
//                                                     </div>
//                                                 )}
//                                                 {/* Show timestamp separately for image-only messages */}
//                                                 {!msg.content && msg.image && (
//                                                     <p className={`text-xs mt-1 flex items-center gap-1.5 ${isSender ? 'text-gray-600 justify-end' : 'text-gray-500'
//                                                         }`}>
//                                                         {formatTime(msg.createdAt)}
//                                                         {isSender && (
//                                                             msg.isRead ? (
//                                                                 <FiCheckCircle size={12} className="flex-shrink-0" />
//                                                             ) : (
//                                                                 <FiCheck size={12} className="flex-shrink-0" />
//                                                             )
//                                                         )}
//                                                     </p>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     );
//                                 })}

//                                 {/* Sending message indicator */}
//                                 {sending && (
//                                     <div className="flex gap-3 justify-end animate-fadeIn">
//                                         <div className="max-w-xs lg:max-w-md">
//                                             {sendingImagePreview && (
//                                                 <div className="mb-2 rounded-lg overflow-hidden opacity-70">
//                                                     <img
//                                                         src={sendingImagePreview}
//                                                         alt="Sending"
//                                                         className="max-w-xs h-auto rounded-lg shadow-sm"
//                                                     />
//                                                 </div>
//                                             )}
//                                             {sendingMessageText && (
//                                                 <div className="px-4 py-2.5 rounded-lg shadow-sm bg-primary-400 text-white rounded-br-none opacity-70">
//                                                     <p className="break-words text-sm leading-relaxed">{sendingMessageText}</p>
//                                                     <p className="text-xs mt-1.5 flex items-center gap-1.5 text-primary-100">
//                                                         <FiLoader className="animate-spin" size={12} />
//                                                         <span>Sending...</span>
//                                                     </p>
//                                                 </div>
//                                             )}
//                                             {!sendingMessageText && sendingImagePreview && (
//                                                 <p className="text-xs mt-1 flex items-center gap-1.5 text-gray-600 justify-end">
//                                                     <FiLoader className="animate-spin" size={12} />
//                                                     <span>Sending...</span>
//                                                 </p>
//                                             )}
//                                         </div>
//                                     </div>
//                                 )}
//                             </>
//                         )}
//                         <div ref={messagesEndRef} />
//                     </div>

//                     {/* Floating New Messages Button */}
//                     {hasNewMessages && (
//                         <button
//                             onClick={handleScrollToNewMessages}
//                             className="absolute bottom-32 left-1/2 transform -translate-x-1/2 bg-primary-600 text-white px-6 py-3 rounded-full shadow-lg hover:bg-primary-700 transition-all duration-200 flex items-center gap-2 font-semibold animate-bounce"
//                         >
//                             New message
//                             <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
//                             </svg>
//                         </button>
//                     )}

//                     {/* Image Preview */}
//                     {imagePreview && (
//                         <div className="px-6 py-3 bg-gray-50 border-t border-gray-200 flex items-center gap-3">
//                             <img src={imagePreview} alt="Preview" className="h-16 w-16 rounded object-cover shadow-sm" />
//                             <button
//                                 onClick={() => {
//                                     setSelectedImage(null);
//                                     setImagePreview(null);
//                                 }}
//                                 className="text-red-600 hover:text-red-700 transition-colors p-1"
//                             >
//                                 <FiX size={20} />
//                             </button>
//                         </div>
//                     )}

//                     {/* Message Input */}
//                     <form onSubmit={handleSendMessage} className="p-6 border-t border-gray-200 bg-white">
//                         <div className="flex items-center gap-3">
//                             <button
//                                 type="button"
//                                 onClick={() => fileInputRef.current?.click()}
//                                 className="p-2.5 text-gray-600 hover:text-primary-600 hover:bg-gray-100 rounded-lg transition-colors flex-shrink-0"
//                                 disabled={sending}
//                                 title="Attach image"
//                             >
//                                 <FiImage size={20} />
//                             </button>
//                             <input
//                                 ref={fileInputRef}
//                                 type="file"
//                                 accept="image/*"
//                                 onChange={handleImageSelect}
//                                 className="hidden"
//                             />
//                             <input
//                                 type="text"
//                                 value={messageInput}
//                                 onChange={handleMessageInputChange}
//                                 placeholder="Type a message..."
//                                 className="flex-1 px-4 py-2.5 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-600 text-sm transition-all"
//                                 disabled={sending}
//                             />
//                             <button
//                                 type="submit"
//                                 disabled={(!messageInput.trim() && !selectedImage) || sending}
//                                 className="p-2.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center flex-shrink-0 shadow-sm"
//                                 title="Send message"
//                             >
//                                 {sending ? <FiLoader className="animate-spin" size={20} /> : <FiSend size={20} />}
//                             </button>
//                         </div>
//                     </form>
//                 </div>
//             ) : (
//                 <div className="hidden lg:flex flex-1 items-center justify-center bg-white px-3">
//                     <div className="text-center">
//                         <p className="text-gray-500">Select a conversation to start messaging</p>
//                     </div>
//                 </div>
//             )}

//             {/* Image Viewer Modal */}
//             {viewingImage && (
//                 <div
//                     className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center p-4"
//                     onClick={closeImageViewer}
//                 >
//                     <div className="relative max-w-7xl max-h-screen">
//                         {/* Close Button */}
//                         <button
//                             onClick={closeImageViewer}
//                             className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors"
//                             title="Close"
//                         >
//                             <FiX size={24} className="text-gray-800" />
//                         </button>

//                         {/* Toolbar */}
//                         <div className="absolute top-4 left-4 z-10 flex gap-2">
//                             {/* Download Button */}
//                             <button
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     downloadImage();
//                                 }}
//                                 className="p-2 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors"
//                                 title="Download"
//                             >
//                                 <FiDownload size={20} className="text-gray-800" />
//                             </button>

//                             {/* Zoom Out Button */}
//                             <button
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     zoomOut();
//                                 }}
//                                 className="p-2 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors disabled:opacity-50"
//                                 disabled={imageZoom <= 0.5}
//                                 title="Zoom Out"
//                             >
//                                 <FiZoomOut size={20} className="text-gray-800" />
//                             </button>

//                             {/* Zoom Level */}
//                             <div className="px-3 py-2 bg-white rounded-full shadow-lg text-sm font-medium text-gray-800">
//                                 {Math.round(imageZoom * 100)}%
//                             </div>

//                             {/* Zoom In Button */}
//                             <button
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     zoomIn();
//                                 }}
//                                 className="p-2 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors disabled:opacity-50"
//                                 disabled={imageZoom >= 3}
//                                 title="Zoom In"
//                             >
//                                 <FiZoomIn size={20} className="text-gray-800" />
//                             </button>
//                         </div>

//                         {/* Image */}
//                         <div
//                             className="overflow-auto max-h-screen flex items-center justify-center"
//                             onClick={(e) => e.stopPropagation()}
//                         >
//                             <img
//                                 src={viewingImage}
//                                 alt="Full view"
//                                 className="rounded-lg shadow-2xl transition-transform duration-200"
//                                 style={{
//                                     transform: `scale(${imageZoom})`,
//                                     maxWidth: '90vw',
//                                     maxHeight: '90vh',
//                                     objectFit: 'contain'
//                                 }}
//                             />
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default Messages;






import React, { useContext, useEffect, useState, useRef } from 'react';
import { DContext } from '../context/Datacontext';
import Loading from './Loading';
import { fetchConversations, fetchConversationMessages, sendMessage } from '../services/user/messagingService';
import { compressImage } from '../utils/compressImages';
import {
    FiSend,
    FiImage,
    FiLoader,
    FiCheck,
    FiCheckCircle,
    FiSearch,
    FiX,
    FiDownload,
    FiZoomIn,
    FiZoomOut,
} from 'react-icons/fi';
import { LuFullscreen } from "react-icons/lu";
import { IoClose } from "react-icons/io5";

function Messages({ course, setShowMessager }) {
    const { BeURL, currentUser } = useContext(DContext);

    const [loading, setLoading] = useState(true);
    const [conversations, setConversations] = useState([]);
    const [selectedConversation, setSelectedConversation] = useState(null);
    const [messages, setMessages] = useState([]);
    const [messageInput, setMessageInput] = useState('');
    const [selectedImage, setSelectedImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [sending, setSending] = useState(false);
    const [sendingMessageText, setSendingMessageText] = useState('');
    const [sendingImagePreview, setSendingImagePreview] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loadingMessages, setLoadingMessages] = useState(false);
    const [hasNewMessages, setHasNewMessages] = useState(false);
    const [viewingImage, setViewingImage] = useState(null);
    const [imageZoom, setImageZoom] = useState(1);
    const [currentRole, setCurrentRole] = useState(false);

    const messagesEndRef = useRef(null);
    const fileInputRef = useRef(null);
    const previousMessagesRef = useRef([]);
    const previousConversationsRef = useRef([]);
    const isTypingRef = useRef(false);
    const typingTimeoutRef = useRef(null);

    useEffect(() => {
        if (currentUser?.role === "user") {
            setCurrentRole(true);
        } else {
            setCurrentRole(false);
        }
    }, [currentUser]);

    // Fetch conversations
    useEffect(() => {
        if (!BeURL || !currentUser) return;

        const fetchData = async () => {
            try {
                if (previousConversationsRef.current.length === 0) {
                    setLoading(true);
                }

                if (isTypingRef.current) return;

                const result = await fetchConversations({ BeURL });
                if (result.success) {
                    const newConversations = result.conversations || [];
                    const newConversationsStr = JSON.stringify(
                        newConversations.map(c => ({
                            id: c._id,
                            updatedAt: c.updatedAt,
                            lastMessage: c.lastMessage?._id
                        }))
                    );
                    const previousConversationsStr = JSON.stringify(
                        previousConversationsRef.current.map(c => ({
                            id: c._id,
                            updatedAt: c.updatedAt,
                            lastMessage: c.lastMessage?._id
                        }))
                    );

                    if (newConversationsStr !== previousConversationsStr) {
                        setConversations(newConversations);

                        const isFirstLoad = previousConversationsRef.current.length === 0;
                        previousConversationsRef.current = newConversations;

                        if (isFirstLoad && newConversations.length > 0) {
                            setSelectedConversation(newConversations[0]);
                        }
                    }
                }
            } catch (error) {
                console.error('Error loading conversations:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
        const interval = setInterval(fetchData, 15000);
        return () => clearInterval(interval);
    }, [BeURL, currentUser]);

    // Fetch messages when conversation is selected
    useEffect(() => {
        if (!selectedConversation || !BeURL) return;

        let isFirstLoad = true;

        const fetchMessages = async () => {
            try {
                if (isTypingRef.current && !isFirstLoad) return;

                if (isFirstLoad) {
                    setLoadingMessages(true);
                }

                const result = await fetchConversationMessages({
                    BeURL,
                    conversationId: selectedConversation._id,
                    page: 1,
                    limit: 50
                });

                if (result.success) {
                    const newMessages = result.messages || [];
                    const newMessagesStr = JSON.stringify(
                        newMessages.map(m => ({
                            id: m._id,
                            isRead: m.isRead
                        }))
                    );
                    const previousMessagesStr = JSON.stringify(
                        previousMessagesRef.current.map(m => ({
                            id: m._id,
                            isRead: m.isRead
                        }))
                    );

                    if (newMessagesStr !== previousMessagesStr) {
                        const previousLength = previousMessagesRef.current.length;
                        setMessages(newMessages);
                        previousMessagesRef.current = newMessages;

                        if (!isFirstLoad && newMessages.length > previousLength) {
                            const latestMessage = newMessages[newMessages.length - 1];
                            const senderIdStr = typeof latestMessage?.senderId === 'string'
                                ? latestMessage.senderId
                                : latestMessage?.senderId?._id || '';
                            const currentUserIdStr = currentUser?._id || '';
                            const isFromOtherPerson = senderIdStr !== currentUserIdStr;

                            if (isFromOtherPerson) {
                                setHasNewMessages(true);
                            }
                        }
                    }

                    if (isFirstLoad) {
                        setLoadingMessages(false);
                        isFirstLoad = false;
                    }
                }
            } catch (error) {
                console.error('Error loading messages:', error);
                if (isFirstLoad) {
                    setLoadingMessages(false);
                    isFirstLoad = false;
                }
            }
        };

        fetchMessages();

        const checkInterval = () => {
            const currentUserIdStr = currentUser?._id || '';
            const hasUnreadSentMessages = messages.some(msg => {
                const senderIdStr = typeof msg.senderId === 'string' ? msg.senderId : msg.senderId?._id || '';
                return senderIdStr === currentUserIdStr && !msg.isRead;
            });
            return hasUnreadSentMessages ? 3000 : 20000;
        };

        let interval = setInterval(fetchMessages, checkInterval());

        const updateInterval = () => {
            clearInterval(interval);
            interval = setInterval(fetchMessages, checkInterval());
        };

        const intervalUpdater = setInterval(updateInterval, 3000);

        return () => {
            clearInterval(interval);
            clearInterval(intervalUpdater);
        };
    }, [selectedConversation, BeURL, messages, currentUser]);

    const handleScrollToNewMessages = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        setHasNewMessages(false);
    };

    useEffect(() => {
        setHasNewMessages(false);
    }, [selectedConversation]);

    useEffect(() => {
        return () => {
            if (typingTimeoutRef.current) {
                clearTimeout(typingTimeoutRef.current);
            }
        };
    }, []);

    const handleMessageInputChange = (e) => {
        setMessageInput(e.target.value);

        isTypingRef.current = true;

        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }

        typingTimeoutRef.current = setTimeout(() => {
            isTypingRef.current = false;
        }, 3000);
    };

    const handleImageSelect = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        try {
            const compressed = await compressImage(file);
            const reader = new FileReader();

            reader.onloadend = () => {
                setSelectedImage(reader.result);
                setImagePreview(URL.createObjectURL(compressed));
            };

            reader.readAsDataURL(compressed);
        } catch (error) {
            console.error('Error processing image:', error);
        }
    };

    const handleSendMessage = async (e) => {
        e.preventDefault();

        if ((!messageInput.trim() && !selectedImage) || !selectedConversation || sending) return;

        try {
            setSending(true);
            setSendingMessageText(messageInput);
            setSendingImagePreview(imagePreview);

            const result = await sendMessage({
                BeURL,
                conversationId: selectedConversation._id,
                content: messageInput,
                imageData: selectedImage
            });

            if (result.success) {
                setMessages(prev => [...prev, result.data]);
                setMessageInput('');
                setSelectedImage(null);
                setImagePreview(null);

                isTypingRef.current = false;
                if (typingTimeoutRef.current) {
                    clearTimeout(typingTimeoutRef.current);
                    typingTimeoutRef.current = null;
                }

                setTimeout(() => {
                    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            } else {
                alert(result.message || 'Failed to send message. Please try again.');
            }
        } catch (error) {
            console.error('Error sending message:', error);
            alert('Error sending message. Please check your connection and try again.');
        } finally {
            setSending(false);
            setSendingMessageText('');
            setSendingImagePreview(null);
        }
    };

    const filteredConversations = conversations.filter(conv => {
        const otherPerson = currentUser.role === 'user'
            ? conv.instructorId
            : conv.studentId;

        const name = otherPerson?.fullName || '';
        const courseName = conv.courseId?.title || '';

        return name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            courseName.toLowerCase().includes(searchTerm.toLowerCase());
    });

    const getOtherPerson = (conv) => {
        return currentUser.role === 'user' ? conv.instructorId : conv.studentId;
    };

    const formatTime = (date) => {
        const d = new Date(date);
        return d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    };

    const handleImageClick = (imageSrc) => {
        setViewingImage(imageSrc);
        setImageZoom(1);
    };

    const closeImageViewer = () => {
        setViewingImage(null);
        setImageZoom(1);
    };

    const downloadImage = () => {
        if (!viewingImage) return;
        const link = document.createElement('a');
        link.href = viewingImage;
        link.download = `message-image-${Date.now()}.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const zoomIn = () => setImageZoom(prev => Math.min(prev + 0.25, 3));
    const zoomOut = () => setImageZoom(prev => Math.max(prev - 0.25, 0.5));

    if (loading) return <Loading />;

    return (
        <div className={`${currentRole ? "h-[60vh]" : "h-[80vh]"} border rounded-xl flex overflow-hidden bg-white`}>
            {/* Conversations List */}
            <div className={`
                ${selectedConversation ? "hidden lg:flex" : "flex"}
                w-full lg:w-80 border-r border-gray-200 bg-white flex-col
            `}>
                {/* Header */}
                <div className="p-4 border-b border-gray-200">
                    <div className="flex items-center justify-between mb-4">
                        <h2 className="text-xl font-bold text-gray-900">Messages</h2>

                        {/* Mobile close button for the full message box */}
                        <button
                            onClick={() => setShowMessager(false)}
                            className="lg:hidden p-2 rounded-full hover:bg-gray-100 text-gray-600"
                        >
                            <IoClose size={20} />
                        </button>
                    </div>

                    <div className="relative">
                        <FiSearch className="absolute left-3 top-2.5 text-gray-400" size={18} />
                        <input
                            type="text"
                            placeholder="Search conversations..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="w-full pl-10 pr-4 py-2 bg-gray-100 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-600 transition-all"
                        />
                    </div>
                </div>

                {/* Conversations */}
                <div className="flex-1 overflow-y-auto">
                    {filteredConversations.length === 0 ? (
                        <div className="p-6 text-center text-gray-400">
                            <p className="text-sm">No conversations yet</p>
                        </div>
                    ) : (
                        filteredConversations.map((conv) => {
                            const otherPerson = getOtherPerson(conv);
                            const isSelected = selectedConversation?._id === conv._id;
                            const lastMsg = conv.lastMessage;

                            return (
                                <button
                                    key={conv._id}
                                    onClick={() => {
                                        setSelectedConversation(conv);
                                        setMessages([]);
                                    }}
                                    className={`w-full flex items-center gap-3 px-4 py-3 border-b border-gray-100 text-left transition-all duration-200 active:bg-gray-100 ${isSelected ? "bg-primary-50 border-l-4 border-l-primary-600" : "hover:bg-gray-50"
                                        }`}
                                >
                                    <div className="w-11 h-11 sm:w-10 sm:h-10 rounded-full bg-gradient-to-br from-primary-600 to-secondary-600 flex items-center justify-center text-white font-bold text-sm flex-shrink-0">
                                        {otherPerson?.fullName?.charAt(0) || "U"}
                                    </div>

                                    <div className="flex-1 min-w-0">
                                        <div className="flex justify-between items-center gap-2">
                                            <p className="font-semibold text-gray-900 text-sm truncate">
                                                {otherPerson?.fullName || "User"}
                                            </p>

                                            {lastMsg?.createdAt && (
                                                <span className="text-[10px] text-gray-400 whitespace-nowrap">
                                                    {new Date(lastMsg.createdAt).toLocaleTimeString([], {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    })}
                                                </span>
                                            )}
                                        </div>

                                        <p className="text-[11px] text-gray-500 truncate">
                                            {conv.courseId?.title || "Course"}
                                        </p>

                                        {lastMsg && (
                                            <p className="text-xs text-gray-600 truncate mt-0.5">
                                                {lastMsg.content}
                                            </p>
                                        )}
                                    </div>
                                </button>
                            );
                        })
                    )}
                </div>
            </div>

            {/* Messages Panel */}
            {selectedConversation ? (
                <div className={`
                    ${selectedConversation ? "flex" : "hidden"}
                    flex-1 flex-col bg-white
                `}>
                    {/* Header */}
                    <div className="h-16 border-b border-gray-200 flex items-center justify-between px-4 sm:px-6 bg-white shadow-sm">
                        <div className="flex items-center gap-3 min-w-0">
                            <button
                                onClick={() => setSelectedConversation(null)}
                                className="lg:hidden p-2 -ml-2 rounded-full hover:bg-gray-100 text-gray-700"
                                title="Back"
                            >
                                ←
                            </button>

                            <div className="min-w-0">
                                <h3 className="font-semibold text-gray-900 truncate">
                                    {getOtherPerson(selectedConversation)?.fullName || 'User'}
                                </h3>
                                <p className="text-xs text-gray-500 truncate">
                                    {selectedConversation.courseId?.title || 'Course'}
                                </p>
                            </div>
                        </div>

                        <button
                            onClick={() => setShowMessager(false)}
                            className="p-2 rounded-full hover:bg-gray-100 text-gray-700"
                            aria-label="Close messenger"
                        >
                            {currentRole && <IoClose size={20} />}
                        </button>
                    </div>

                    {/* Messages */}
                    <div className="flex-1 overflow-y-auto p-4 sm:p-6 space-y-4 bg-gray-50 relative">
                        {loadingMessages ? (
                            <div className="flex items-center justify-center h-full">
                                <FiLoader className="animate-spin text-primary-600" size={24} />
                            </div>
                        ) : messages.length === 0 ? (
                            <div className="flex items-center justify-center h-full text-center">
                                <div>
                                    <p className="text-gray-500">No messages yet</p>
                                    <p className="text-xs text-gray-400 mt-2">Start the conversation!</p>
                                </div>
                            </div>
                        ) : (
                            <>
                                {messages.map((msg) => {
                                    const senderIdStr = typeof msg.senderId === 'string'
                                        ? msg.senderId
                                        : msg.senderId?._id || '';

                                    const currentUserIdStr = currentUser._id || '';
                                    const isSender = senderIdStr === currentUserIdStr;

                                    return (
                                        <div
                                            key={msg._id}
                                            className={`flex gap-3 animate-fadeIn ${isSender ? 'justify-end' : 'justify-start'}`}
                                        >
                                            <div className={`max-w-[85%] sm:max-w-xs lg:max-w-md ${isSender ? 'order-2' : 'order-1'}`}>
                                                {msg.image && (
                                                    <div
                                                        className="mb-2 rounded-lg overflow-hidden cursor-pointer relative group"
                                                        onClick={() => handleImageClick(msg.image)}
                                                    >
                                                        <img
                                                            src={msg.image}
                                                            alt="Message"
                                                            className="w-full max-w-xs h-auto rounded-lg shadow-sm transition-opacity group-hover:opacity-75"
                                                        />
                                                        <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-200 flex items-center justify-center">
                                                            <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex flex-col items-center gap-2">
                                                                <div className="p-3 bg-white rounded-full shadow-lg">
                                                                    <LuFullscreen size={24} className="text-primary-600" />
                                                                </div>
                                                                <span className="text-white font-semibold text-sm">View Image</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {msg.content && (
                                                    <div
                                                        className={`px-4 py-2.5 rounded-lg shadow-sm ${isSender
                                                            ? 'bg-primary-600 text-white rounded-br-none'
                                                            : 'bg-white text-gray-900 rounded-bl-none border border-gray-200'
                                                            }`}
                                                    >
                                                        <p className="break-words text-sm leading-relaxed">{msg.content}</p>
                                                        <p className={`text-xs mt-1.5 flex items-center gap-1.5 ${isSender ? 'text-primary-100' : 'text-gray-500'
                                                            }`}>
                                                            {formatTime(msg.createdAt)}
                                                            {isSender && (
                                                                msg.isRead ? (
                                                                    <FiCheckCircle size={12} className="flex-shrink-0" />
                                                                ) : (
                                                                    <FiCheck size={12} className="flex-shrink-0" />
                                                                )
                                                            )}
                                                        </p>
                                                    </div>
                                                )}

                                                {!msg.content && msg.image && (
                                                    <p className={`text-xs mt-1 flex items-center gap-1.5 ${isSender ? 'text-gray-600 justify-end' : 'text-gray-500'
                                                        }`}>
                                                        {formatTime(msg.createdAt)}
                                                        {isSender && (
                                                            msg.isRead ? (
                                                                <FiCheckCircle size={12} className="flex-shrink-0" />
                                                            ) : (
                                                                <FiCheck size={12} className="flex-shrink-0" />
                                                            )
                                                        )}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}

                                {sending && (
                                    <div className="flex gap-3 justify-end animate-fadeIn">
                                        <div className="max-w-[85%] sm:max-w-xs lg:max-w-md">
                                            {sendingImagePreview && (
                                                <div className="mb-2 rounded-lg overflow-hidden opacity-70">
                                                    <img
                                                        src={sendingImagePreview}
                                                        alt="Sending"
                                                        className="w-full max-w-xs h-auto rounded-lg shadow-sm"
                                                    />
                                                </div>
                                            )}

                                            {sendingMessageText && (
                                                <div className="px-4 py-2.5 rounded-lg shadow-sm bg-primary-400 text-white rounded-br-none opacity-70">
                                                    <p className="break-words text-sm leading-relaxed">{sendingMessageText}</p>
                                                    <p className="text-xs mt-1.5 flex items-center gap-1.5 text-primary-100">
                                                        <FiLoader className="animate-spin" size={12} />
                                                        <span>Sending...</span>
                                                    </p>
                                                </div>
                                            )}

                                            {!sendingMessageText && sendingImagePreview && (
                                                <p className="text-xs mt-1 flex items-center gap-1.5 text-gray-600 justify-end">
                                                    <FiLoader className="animate-spin" size={12} />
                                                    <span>Sending...</span>
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}

                        <div ref={messagesEndRef} />

                        {hasNewMessages && (
                            <button
                                onClick={handleScrollToNewMessages}
                                className="absolute bottom-6 left-1/2 transform -translate-x-1/2 bg-primary-600 text-white px-4 py-2 rounded-full shadow-lg hover:bg-primary-700 transition-all duration-200 flex items-center gap-2 font-semibold text-sm"
                            >
                                New message
                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                                </svg>
                            </button>
                        )}
                    </div>

                    {/* Image Preview */}
                    {imagePreview && (
                        <div className="px-4 sm:px-6 py-3 bg-gray-50 border-t border-gray-200 flex items-center gap-3">
                            <img
                                src={imagePreview}
                                alt="Preview"
                                className="h-16 w-16 rounded object-cover shadow-sm"
                            />
                            <div className="flex-1 min-w-0">
                                <p className="text-xs text-gray-500 truncate">Image ready to send</p>
                            </div>
                            <button
                                onClick={() => {
                                    setSelectedImage(null);
                                    setImagePreview(null);
                                }}
                                className="text-red-600 hover:text-red-700 transition-colors p-1"
                            >
                                <FiX size={20} />
                            </button>
                        </div>
                    )}

                    {/* Message Input */}
                    <form onSubmit={handleSendMessage} className="p-3 sm:p-4 md:p-6 border-t border-gray-200 bg-white">
                        <div className="flex items-center gap-2 sm:gap-3">
                            <button
                                type="button"
                                onClick={() => fileInputRef.current?.click()}
                                className="p-2.5 text-gray-600 hover:text-primary-600 hover:bg-gray-100 rounded-lg transition-colors flex-shrink-0"
                                disabled={sending}
                                title="Attach image"
                            >
                                <FiImage size={20} />
                            </button>

                            <input
                                ref={fileInputRef}
                                type="file"
                                accept="image/*"
                                onChange={handleImageSelect}
                                className="hidden"
                            />

                            <input
                                type="text"
                                value={messageInput}
                                onChange={handleMessageInputChange}
                                placeholder="Type a message..."
                                className="flex-1 px-4 py-2.5 bg-gray-100 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-600 text-sm transition-all"
                                disabled={sending}
                            />

                            <button
                                type="submit"
                                disabled={(!messageInput.trim() && !selectedImage) || sending}
                                className="p-2.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center flex-shrink-0 shadow-sm"
                                title="Send message"
                            >
                                {sending ? <FiLoader className="animate-spin" size={20} /> : <FiSend size={20} />}
                            </button>
                        </div>
                    </form>
                </div>
            ) : (
                <div className="hidden lg:flex flex-1 items-center justify-center bg-white px-3">
                    <div className="text-center">
                        <p className="text-gray-500">Select a conversation to start messaging</p>
                    </div>
                </div>
            )}

            {/* Image Viewer Modal */}
            {viewingImage && (
                <div
                    className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center p-4"
                    onClick={closeImageViewer}
                >
                    <div className="relative max-w-7xl max-h-screen">
                        <button
                            onClick={closeImageViewer}
                            className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors"
                            title="Close"
                        >
                            <FiX size={24} className="text-gray-800" />
                        </button>

                        <div className="absolute top-4 left-4 z-10 flex gap-2">
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    downloadImage();
                                }}
                                className="p-2 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors"
                                title="Download"
                            >
                                <FiDownload size={20} className="text-gray-800" />
                            </button>

                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    zoomOut();
                                }}
                                className="p-2 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors disabled:opacity-50"
                                disabled={imageZoom <= 0.5}
                                title="Zoom Out"
                            >
                                <FiZoomOut size={20} className="text-gray-800" />
                            </button>

                            <div className="px-3 py-2 bg-white rounded-full shadow-lg text-sm font-medium text-gray-800">
                                {Math.round(imageZoom * 100)}%
                            </div>

                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    zoomIn();
                                }}
                                className="p-2 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors disabled:opacity-50"
                                disabled={imageZoom >= 3}
                                title="Zoom In"
                            >
                                <FiZoomIn size={20} className="text-gray-800" />
                            </button>
                        </div>

                        <div
                            className="overflow-auto max-h-screen flex items-center justify-center"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <img
                                src={viewingImage}
                                alt="Full view"
                                className="rounded-lg shadow-2xl transition-transform duration-200"
                                style={{
                                    transform: `scale(${imageZoom})`,
                                    maxWidth: '90vw',
                                    maxHeight: '90vh',
                                    objectFit: 'contain'
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Messages;